#@import Backbone
#@import DealCarousel.Helpers
#@import DealCarousel.Media
#@import DealCarousel.View
#@import I18n
#@export DealCarousel

window.DealCarousel ?= {}

DealCarousel.carouselViews = {}
DealCarousel.dealMedia = {}
DealCarousel.current = {}

{getMedia, prepareCarouselOptions, setVideoLoaderFlags, loadVideoScripts, loadScripts} = DealCarousel.Helpers

DealCarousel.init = ({carousel, featuredImage}, done) ->
  {dealId, enabled} = carousel
  return done?() unless enabled

  {media, showVideos} = getMedia carousel
  @i18n ?= I18n.scoped 'modules.groupon-deal-carousel'

  @dealMedia[dealId] = currentDealMedia = new Backbone.Collection media,
    model: DealCarousel.Media
  @current.currentDealMedia = currentDealMedia

  carouselOptions = prepareCarouselOptions carousel, currentDealMedia, featuredImage, @i18n
  @carouselViews[dealId] = currentCarouselView = new DealCarousel.View carouselOptions
  @current.currentCarouselView = currentCarouselView

  {loadKaltura, loadOoyala, loadYoutube} = setVideoLoaderFlags showVideos, carousel

  $ =>
    loadVideoScripts carousel, currentCarouselView, loadKaltura, loadOoyala, loadYoutube
    loadScripts carouselOptions
    currentCarouselView.render()
    done?()

DealCarousel.updateCurrent = ({carousel, featuredImage}) ->
  return unless @current.currentDealMedia and @current.currentCarouselView
  {dealId, enabled} = carousel
  return unless enabled

  delete @dealMedia[@current.currentDealMedia.uuid]
  delete @carouselViews[@current.currentDealMedia.uuid]

  {media, showVideos} = getMedia carousel

  @current.currentDealMedia.reset media,
    model: DealCarousel.Media

  carouselOptions = prepareCarouselOptions carousel, @current.currentDealMedia, featuredImage, @i18n
  @current.currentCarouselView.options = carouselOptions

  @current.currentCarouselView.initialize()
  @current.currentCarouselView.updateCollection @current.currentDealMedia

  {loadKaltura, loadOoyala, loadYoutube} = setVideoLoaderFlags showVideos, carousel

  $ =>
    loadVideoScripts carousel, @current.currentCarouselView, loadKaltura, loadOoyala, loadYoutube
